export const ORDER_TABS_LIST = {
  WholesaleOrders: {
    label: 'Wholesale Orders',
    value: 'wholesaleOrders'
  },
  WholesaleDeletedOrders: {
    label: 'Wholesale Deleted Orders',
    value: 'wholesaleDeletedOrders'
  },
  RetailOrders: {
    label: 'Retail Orders',
    value: 'retailOrders'
  },
  RetailDeletedOrders: {
    label: 'Retail Deleted Orders',
    value: 'retailDeletedOrders'
  }
}
